import { render, staticRenderFns } from "./distributionOrder.vue?vue&type=template&id=6409d8fa&"
import script from "./distributionOrder.vue?vue&type=script&lang=js&"
export * from "./distributionOrder.vue?vue&type=script&lang=js&"
import style0 from "./distributionOrder.vue?vue&type=style&index=0&id=6409d8fa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports